import React from "react";
import Strip from "../TCP-HP/Strip";
import GovtStrip from "../TCP-HP/GovtStrip";
import Navbar from "../TCP-HP/Navbar";
import Development from "./Banner/Development";
import Services from "./Services";
import AboutUs from "./AboutUs";
import AppInfo from "./AppInfo";
import CitizenFacilitation from "./Facilation";
import FeedbackComplaint from "./FeedbackComplaint";
import LinksSlideshow from "../TCP-HP/LinksSlideShow";
import Footer from "./Footer";

function NewTcp(){
    return(
        <React.Fragment>
            <Strip />
            <GovtStrip />
            <Navbar />
            <Development />
            <Services />  
            <AboutUs />   
            <AppInfo />
            <CitizenFacilitation />
            <FeedbackComplaint />
            <LinksSlideshow />
            <Footer />
        </React.Fragment>
    )
}

export default NewTcp